import * as Yup from 'yup';

const validationSchema = (t, unreconciledAmount, toleranceAmount = 0) =>
  Yup.object().shape({
    contract: Yup.object()
      .nullable()
      .required(t('SANTANDER_REPORTS.CONTRACT_REQUIRED')),
    isPayoffRequest: Yup.boolean(),
    amount: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value
      )
      .when('isPayoffRequest', {
        is: false,
        then: schema =>
          schema
            .required(t('SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'))
            .min(0.01, t('SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'))
      })
      .when('isPayoffRequest', {
        is: true,
        then: schema =>
          schema.min(0.01, t('SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'))
      })
      .test(
        'max-unreconciled',
        t('SANTANDER_REPORTS.AMOUNT_EXCEEDS_UNRECONCILED'),
        function testMaxUnreconciled(value) {
          if (this.parent.isPayoffRequest) return true;
          if (value == null || value === '') return true;
          const max = Number(unreconciledAmount) || 0;
          const tolerance = Number(toleranceAmount) || 0;
          return Number(value) <= max + tolerance;
        }
      )
  });

export default validationSchema;
